import { oktaClient as api } from '@modules/core/services';
import { Factor } from '../types/factor.types';

export const fetchFactors = async (userId: string): Promise<Factor[] | undefined> => {
  return await api.get(`users/${userId}/factors`);
};
